import _ from 'underscore';
import { ProjectionGridBaseColumn } from '@bingads-webui/projection-grid-base-column';
import { ISSUE_TYPES } from '@bingads-webui-campaign/recommendation-core';

export class IssueTypeColumn extends ProjectionGridBaseColumn {
  constructor({ newI18n, s$i18n }) {
    super({
      name: 'IssueType',
      property: 'IssueType',
      title: newI18n.getString(_TL_('Issue type')),
      bodyClasses: ['grid-column-issueType', 'actionable'],
      colClasses: ['col-normalText'],
      sortable: true,
      type: 'string',
      helpId: 'pop_BA_UET_Type',
    });
    this.newI18n = newI18n;
    this.s$i18n = s$i18n;
  }

  template({
    value: {
      Opportunities,
    },
  }) {
    return ISSUE_TYPES[Opportunities[0].IssueType] || this.s$i18n.value('Goal', 'Type', Opportunities[0].GoalTypeCode);
  }

  get property() {
    return {
      get: _.identity,
      property: 'IssueType',
    };
  }
}
